import { render } from "./TategakiQA.vue?vue&type=template&id=44de887e&scoped=true&ts=true"
import script from "./TategakiQA.vue?vue&type=script&lang=ts"
export * from "./TategakiQA.vue?vue&type=script&lang=ts"

import "./TategakiQA.vue?vue&type=style&index=0&id=44de887e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44de887e"]])

export default __exports__